import { appI18n } from '@flowus/common/i18n';

export enum MenuListActionType {
  DELETE = 1,
  COPY,
  RENAME,
  MOVETO,
  TURN_INTO,
  CREATE,
  COLOR,
  // 下面两个是内嵌多维表特殊的菜单，转换为页面以及从页面转换为内嵌多维表
  TURN_TO_PAGE,
  TURN_TO_EMBED, // 转换为内嵌，包括多维表和思维导图
  TEMPLATE,
  TABLE_CONVERT,
  COPY_MOVE,
  CUT,
  COPY_CLIPBOARD,
  OPEN_RIGHT_PAGE,
  AI_EDITOR,
  OPEN_TAB,
}

export enum InlineContentType {
  DATE = 'date',
  PEOPLE = 'people',
  LINK_PAGE = 'link_page',
  EQUATION = 'equation',
  EMOJI = 'emoji',
  PAGE = 'page',
}

export const getMenuCategory = () =>
  ({
    aiAssistantWithEmptyDoc: appI18n.t('common.ai_assistant'),
    aiAssistantWithNotEmptyDoc: appI18n.t('common.ai_assistant'),
    basicBlock: appI18n.t('editor.menu_list.basic_block'),
    media: appI18n.t('editor.menu_list.media'),
    embed: appI18n.t('editor.menu_list.embed'),
    inlineElement: appI18n.t('editor.menu_list.inline_element'),
    layout: appI18n.t('editor.menu_list.layout'),
    turninto: appI18n.t('common.convert_to'),
    action: appI18n.t('common.action'),
    lastUsedColor: appI18n.t('common.last_used_color'),
    color: appI18n.t('components.color_picker.text_color'),
    colorBackground: appI18n.t('components.color_picker.background_color'),
    database: appI18n.t('components.new_user_task.page_types.table'),
    advanced: appI18n.t('editor.menu_list.advanced_block'),
  } as const);

export type MenuCategory = ReturnType<typeof getMenuCategory>;
export const MenuCategory = getMenuCategory();
